const urlService = {}

urlService.getUrl = service => {
  const isProduction = process.env.REACT_APP_ENV === 'production'
  const isDevelopment = process.env.REACT_APP_ENV === 'development'

  switch (service) {
    case 'cloud': {
      if (isProduction) {
        return 'https://cloud.metrica-sports.com'
      } else if (isDevelopment) {
        return 'http://cloud-dev.metrica-sports.com'
      }

      return 'http://localhost:3018'
    }

    case 'registry': {
      if (isProduction) {
        return 'https://getplay.metrica-sports.com'
      } else if (isDevelopment) {
        return 'http://getplay-dev.metrica-sports.com'
      }

      return 'http://localhost:3019'
    }

    case 'downloads': {
      if (isProduction) {
        return 'https://downloads.metrica-sports.com'
      } else if (isDevelopment) {
        return 'http://downloads-dev.metrica-sports.com'
      }

      return 'http://localhost:3020'
    }

    default:
      console.error(`Service ${service} not recognized`)
      break
  }

  return ''
}

export default urlService
